// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Iadg","vLegacy":"SelectSecondary_vLegacy__2Cz6Y","error":"SelectSecondary_error__wVqNG","disabled":"SelectSecondary_disabled__34SGI"};